<div class="card" *blockUI="'section-block'">
    <div class="row d-flex align-items-center mt-1 mb-1">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center ml-1">
          <div class="col-xl-7 col-md-8 col-sm-12 col-12" *ngIf="authService.isEndpointStatus('POST.Writing.CreateBrand')">
            <input type="text" class="form-control" id="basicInput" placeholder="Marka giriniz."
              [(ngModel)]="createBrandName" style="padding: 10px; font-size: 16px; box-sizing: border-box;" />
          </div>
  
          <div *ngIf="authService.isEndpointStatus('POST.Writing.CreateBrand')">
            <button type="button" class="btn btn-success" rippleEffect (click)="createBrand()"
              [disabled]="!createBrandName">
              <span [data-feather]="'plus'" [class]="'mr-25'"></span>Marka Ekle
            </button>
          </div>
        </div>
  
        <div class="d-flex align-items-center mx-1">
          <label class="d-flex align-items-center">
            <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="50">50</option>
            </select>
          </label>
  
          <label class="d-flex align-items-center">
            <input type="search" placeholder="Bul" class="form-control ml-25" (keyup)="filterUpdate($event)"
              (search)="filterUpdate($event)" />
          </label>
        </div>
      </div>
    </div>
    
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
      [scrollbarH]="true">
  
      <ngx-datatable-column name="Marka Adı">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          <div *ngIf="!isEditingRow(row.id)">
            {{ row.brandName }}
          </div>
          <div *ngIf="isEditingRow(row.id)">
            <input type="text" class="form-control" id="basicInput" [(ngModel)]="row.brandName" />
          </div>
        </ng-template>
      </ngx-datatable-column>
  
      <ngx-datatable-column name="" [width]="120" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="d-flex align-items-center">
  
            <a *ngIf="!isEditingRow(row.id) && authService.isEndpointStatus('PUT.Updateing.UpdateBrand')" (click)="editRow(row.id)">
              <i data-feather="edit" class="text-info cursor-pointer mr-1"></i>
            </a>
            <a *ngIf="isEditingRow(row.id) && authService.isEndpointStatus('PUT.Updateing.UpdateBrand')" (click)="saveRow(row.id)">
              <i data-feather="save" class="text-success cursor-pointer mr-1"></i>
            </a>
            <a class="mr-1" *ngIf="isEditingRow(row.id) && authService.isEndpointStatus('PUT.Updateing.UpdateBrand')" (click)="cancelEdit(row.id)">
              <i data-feather="x" class="text-danger cursor-pointer"></i>
            </a>
            <a appDelete controller="brands" [id]="row.id" (callback)="getAllBrand(0,5,'')" *ngIf="authService.isEndpointStatus('DELETE.Deleteing.RemoveBrand')">
              <i data-feather="trash" class="text-danger cursor-pointer"></i>
            </a>
  
          </div>
        </ng-template>
      </ngx-datatable-column>
  
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <div class="datatable-footer-inner">
            <div class="page-count">
              Toplam Veri {{ totalCount }}
            </div>
            <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
              (pageChange)="onPageChange($event)" [maxSize]="5">
              <ng-template ngbPaginationPrevious>
                <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
              </ng-template>
              <ng-template ngbPaginationNext>
                <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
              </ng-template>
            </ngb-pagination>
          </div>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>